/**
 * Route paths needed outside the router itself (mobile redirect, initial modal
 * flow). Kept free of asset imports so importing it does not pull a lazy
 * route's chunk into the main bundle.
 */
export const PARTNER_ROUTE_PREFIX = '/partner'
export const PARTNER_ROUTE_PATH = `${PARTNER_ROUTE_PREFIX}/:slug`

/**
 * Matches the prefix on a path-segment boundary, so a future `/partnerships`
 * route cannot accidentally inherit the partner-page behaviour.
 */
export function isPartnerRoute(pathname: string): boolean {
  return pathname === PARTNER_ROUTE_PREFIX || pathname.startsWith(`${PARTNER_ROUTE_PREFIX}/`)
}
